// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollPaymentDataObject  {
    _originalTypeClassName = "Loom.BO.PayrollPaymentDataObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollPaymentDataObject.translate = translateService;
}
this.Id = null;
this.EmployeeCode = null;
this.EmployeeFullName = null;
this.Month = null;
this.Year = null;
this.Description = null;
this.GrossSalary = null;
this.TotalSocialSecurityCost = null;
this.TaxAmount = null;
this.NetSalary = null;
this.TotalCost = null;
this.Days = null;
this.OrganisationShortName = null;
this.PayableAmount = null;
this.VATAmount = null;
this.Hours = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EmployeeCode:any;
EmployeeFullName:any;
Month:any;
Year:any;
Description:any;
GrossSalary:any;
TotalSocialSecurityCost:any;
TaxAmount:any;
NetSalary:any;
TotalCost:any;
Days:any;
OrganisationShortName:any;
PayableAmount:any;
VATAmount:any;
Hours:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}